<template lang="pug">
div
  v-row
    v-col(cols="8")
      v-form(ref="form")
        v-card.pa-6.mt-4.round-xl(outlined)
          div.text-md.font-semibold.neutral700--text Set your number of rewards
          .text-sm.neutral700--text(style="margin-top: 2px;") Set number of rewards, on which stamp number, and reward name.
          template(v-for="(reward, index) in rewards")
            v-card.round-xl.pa-6.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;" :key="`rw-${index}`")
              v-row(dense)
                v-col.shrink
                  div.pr-4
                    div.text-sm.font-medium.neutral700--text #
                    div.text-sm.font-medium.neutral700--text.mt-6 {{ index + 1 }}
                v-col(cols="4")
                  div
                    div.text-sm.font-medium.neutral700--text On stamp number:
                    y-select.mt-2(v-model="reward.tier_value" background-color="neutral100" placeholder="Select stamp number" attach :items="stampNumber" item-value="value" item-text="text" :rules="rules.not_empty_select")
                v-col.grow
                  div
                    div.text-sm.font-medium.neutral700--text Reward name
                    v-text-field.text-sm.mt-2.round-xl(v-model="reward.name" background-color="neutral100" placeholder="Enter reward name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
              yc-checkbox.mt-5(v-model="reward.attach_products")
                template(v-slot:label)
                  div.text-md.font-semibold.ml-3 Attach inventory or services to this reward
              div.pl-4(v-if="reward.attach_products")
                v-radio-group.mt-0(v-model="reward.all_products")
                  v-radio.mt-3(:value="true" color="neutral700")
                    template(v-slot:label)
                      div.text-md.font-medium.neutral700--text Attach all inventory & services
                  v-radio.mt-3(:value="false" color="neutral700" style="align-items: unset;")
                    template(v-slot:label)
                      div.text-md.font-medium.neutral700--text Attach specific inventory & services
                template(v-if="reward.hasOwnProperty('all_products') && !reward.all_products")
                  inventory-services-selection(v-model="reward.products")
              div.d-flex.mt-4(v-if="rewards.length > 1")
                v-spacer
                y-button(label="Remove" outlined prepend-icon="$yzi-trash-03" size="sm" @click="removeReward(index)")

          y-button.mt-6(label="Add more" prepend-icon="$yzi-plus" size="sm" @click="rewards.push({ products: [] })")

        v-card.pa-6.mt-4.round-xl(outlined)
          div.text-md.font-semibold.neutral700--text Upload logo
          v-row.mt-5(dense align="center")
            v-col.shrink
              div(style="width: 70px;")
                v-responsive(:aspect-ratio="1")
                  v-card.fill-height.round-xl(v-if="resizeImageFileUrl" flat)
                    v-img(:src="resizeImageFileUrl" height="70px" width="70px")
                      template(v-slot:placeholder)
                        v-row(class="fill-height ma-0" align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
                  v-card.neutral300.fill-height.round-xl(v-else flat)
                    div.d-flex.align-center.justify-center.fill-height
                      v-icon(color="neutral500" size="45") $yzi-image-01
            v-col.grow
              div.pl-3
                div.text-sm.font-semibold.neutral700--text Company logo
                div.text-sm.neutral700--text.mt-2 Company logo has to be 1:1 (Square) dimension. File must be PNG or JPEG
            v-col.shrink
              y-button(v-if="loyaltySettings.logo" label="Remove" size="sm" :loading="isLoading" outlined block button-class="px-3" @click="removeImage(loyaltySettings.logo.id)")
              div.file-change-layout(v-else)
                div(style="width: 80px;")
                  y-button(label="Upload" size="sm" outlined block button-class="px-3")
                input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 80px !important")

        v-card.pa-6.mt-4.round-xl(outlined)
          div.text-md.font-semibold.neutral700--text T&C
          v-card.pa-6.mt-4.round-xl(outlined)
            div.text-md.font-semibold.neutral700--text Terms and condition to your customer
            ol.mt-5
              li.text-md.neutral700--text Membership is non-transferable and is valid only for the registered cardholder.
              li.text-md.neutral700--text Points are not transferable between accounts and have no cash value.
              li.text-md.neutral700--text Redemption requests must adhere to the stipulated terms and conditions and may be subject to availability.
              li.text-md.neutral700--text Loyalty points may expire if the card has been inactive for a specified period, as outlined in the program guidelines.
              li.text-md.neutral700--text Changes to the program will be communicated to members through the provided contact information.
              li.text-md.neutral700--text The company reserves the right to take legal action against any individual found engaging in fraudulent activities.
              li.text-md.neutral700--text Member information collected during enrollment will be used solely for program-related purposes and will not be shared with third parties without consent.
              li.text-md.neutral700--text The company reserves the right to terminate a member's participation in the program for any reason, including violation of program rules or improper conduct.

    v-col(cols="4")
      
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import SegmentSelection from '@/components/clinic/marketing/SegmentSelection.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'

export default {
  components: { InventoryServicesSelection, SegmentSelection, DatePickerField },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      resizeImageFileUrl: null,
      resizeImageFile: null,
      rewards: [{ products: [] }],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      loyaltySettings: 'marketing/getLoyaltySettings'
    }),
    stampNumber () {
      let numbers = []
      for (let i = 1; i <=10; i++) {
        let obj = { text: i, value: i, disabled: false }
        if (this.rewards.map(m => m.tier_value).includes(i)) {
          obj.disabled = true
        }
        numbers.push(obj)
      }
      return numbers
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.rewards = this.loyaltySettings.rewards
      this.resizeImageFileUrl = this.loyaltySettings?.logo?.file || null
    },
    removeReward (idx) {
      this.rewards.splice(idx, 1)
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      let rewards = JSON.parse(JSON.stringify(this.rewards))
      rewards.forEach(reward => {
        if (!reward.attach_products) {
          delete reward.all_products
          delete reward.products
        }
        if (reward.all_products) {
          delete reward.products
        } else if (reward.products) {
          reward.products = reward.products.map(m => m.id)
        }
      })
      let payload = { rewards }
      this.$axios.patch(`/loyalty/${this.company.slug}`, payload)
        .then(resp => {
          if (this.resizeImageFile) {
            this.updateImage()
          } else {
            this.updateSuccess(resp)
          }
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.$emit('error')
        })
    },
    updateImage () {
      var formdata = new FormData()
      formdata.append('logo', this.resizeImageFile)
      this.$axios.patch(`/loyalty/${this.company.slug}`, formdata)
        .then(resp => {
          this.updateSuccess(resp)
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_upload_image')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.$emit('error')
        })
    },
    removeImage (id) {
      this.isLoading = true
      this.$axios.delete(`/images/${id}`)
        .then(() => {
          let data = this.loyaltySettings
          data.logo = null
          this.$store.commit('marketing/setLoyaltySettings', data)
          this.$nextTick(() => {
            this.setData()
          })
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_upload_image')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.$emit('error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateSuccess (resp) {
      this.$store.commit('marketing/setLoyaltySettings', resp.data)
      this.showMessage(['success', this.$t('success_message.successfully_updated')])
      this.$emit('updated')
      this.$nextTick(() => {
        this.setData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>